<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    title="测试用例编辑"
    width="80%"
    height="80%"
    show-zoom
    remember
    @zoom="handleZoom"
    @show="showModal"
  >
    <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
      <!-- 第一行 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="产品类型" prop="productionType">
            <el-select
              clearable
              v-model="form.productionType"
              :placeholder="placeholderConfig.select"
              :disabled="!Authority.edit || form.lockerID > 0 || cantEdit"
              @change="changeType"
            >
              <el-option
                v-for="i of ComBoxItems.productionType"
                :key="i.name + ''"
                :label="i.name"
                :value="i.value"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产品版本" prop="productionVersion">
            <el-select
              clearable
              v-model="form.productionVersion"
              :placeholder="placeholderConfig.select"
              :disabled="!Authority.edit || form.lockerID > 0 || cantEdit"
            >
              <el-option
                v-for="i of ComBoxItems.productionVersion"
                :key="i.name + ''"
                :label="i.name"
                :value="i.value"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用例标题" prop="todo1">
            <el-input
              v-model="form.todo1"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || form.lockerID > 0 || cantEdit"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 第二行 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="优先级" prop="todo2">
            <el-input
              v-model="form.todo2"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || form.lockerID > 0 || cantEdit"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用例状态" prop="todo3">
            <el-input
              v-model="form.todo3"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || form.lockerID > 0 || cantEdit"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用例类型" prop="todo4">
            <el-input
              v-model="form.todo4"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || form.lockerID > 0 || cantEdit"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="适用阶段" prop="todo5">
            <el-input
              v-model="form.todo5"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || form.lockerID > 0 || cantEdit"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 第三行 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="关键词" prop="todo6">
            <el-input
              v-model="form.todo6"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || form.lockerID > 0 || cantEdit"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="前置条件" prop="todo7">
            <el-input
              v-model="form.todo7"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || form.lockerID > 0 || cantEdit"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <YKDivider content-position="left">明细数据</YKDivider>
    <vxe-toolbar>
      <template #buttons>
        <vxe-button size="mini" @click="insertOne">新增明细</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      ref="xTable"
      :show-overflow="false"
      :column-config="{ resizable: true }"
      :height="tableHeight"
      :scroll-y="{
        mode: 'wheel'
      }"
      :data="form.detailList"
      :edit-rules="validRules"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod
      }"
      :mouse-config="{ area: true, extension: true }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: true,
        editMethod: editMethod
      }"
      :clip-config="{
        beforePasteMethod: beforePasteMethod,
        pasteMethod: pasteMethod,
        afterPasteMethod: afterPasteMethod
      }"
      :tree-config="{
        transform: true,
        rowField: 'pid',
        parentField: 'parentId'
      }"
      :menu-config="{
        body: { options: bodyMenus },
        visibleMethod: visibleMethod
      }"
      @menu-click="contextMenuClickEvent"
      @cell-dblclick="handleDbClick"
    >
      <vxe-column type="seq" width="40px"></vxe-column>
      <vxe-column width="50px" title="节点">
        <template #default="{ row }">
          <span v-if="row.parentId === -1"> 父 </span>
          <span v-else> 子 </span>
        </template>
      </vxe-column>
      <vxe-column
        field="todo99"
        title="步骤"
        tree-node
        :edit-render="{ name: '$input', attrs: { disabled: true } }"
      ></vxe-column>
      <vxe-column field="todo98" title="预期" :edit-render="{ name: '$input', attrs: { disabled: true } }"></vxe-column>
    </vxe-table>
    <!-- 间隔槽（内含保存按钮） -->
    <div class="buttonContainer">
      <el-button type="primary" @click="save">保存</el-button>
    </div>
    <!-- 明细修改 -->
    <DetailUpdateModal ref="DetailUpdateModal" :updateRow.sync="updateRow" :isParent="updateRowIsParent" />
  </vxe-modal>
</template>
<script>
import DetailUpdateModal from './DetailUpdateModal.vue'
export default {
  components: {
    DetailUpdateModal
  },
  data() {
    return {
      // 窗口是否显示
      formVisible: false,
      // 权限获取
      Authority: this.AuthorityFilter(this.$route.path),
      // 表单
      form: {
        productionType: '',
        productionVersion: '',
        todo1: '',
        todo2: '',
        todo3: '',
        todo4: '',
        todo5: '',
        todo6: '',
        todo7: '',
        todo8: '',
        lockDate: '',
        locker: '',
        lockerID: 0,
        writeDate: '',
        writer: '',
        writerID: 0,
        detailList: []
      },
      // 是否不能编辑
      cantEdit: false,
      // 校验规则
      rules: {},
      // 下拉框
      ComBoxItems: {
        productionVersion: [],
        productionType: []
      },
      // 粘贴区域
      pasteAreaList: [],
      // 明细校验规则
      validRules: {},
      // 右键菜单
      bodyMenus: [
        [
          {
            code: 'insertRow',
            name: '插入子节点'
          }
        ]
      ],
      // 明细修改缓存row
      updateRow: {},
      // 修改的明细是否为父节点
      updateRowIsParent: false,
      // 当前模态窗状态
      zoomType: 'revert'
    }
  },
  methods: {
    // 窗口缩放事件
    handleZoom({ type }) {
      this.zoomType = type
    },
    // todo 保存事件
    save() {
      this.formVisible = false
    },
    // 双击事件
    handleDbClick({ row }) {
      row.parentId === -1 ? (this.updateRowIsParent = true) : (this.updateRowIsParent = false)
      this.updateRow = row
      this.$nextTick(() => {
        this.$refs.DetailUpdateModal.formVisible = true
      })
    },
    // 右键控制菜单方法
    visibleMethod({ options, column, row }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          if (column) {
            row.parentId === -1 ? (item.visible = true) : (item.visible = false)
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    async contextMenuClickEvent({ menu, row }) {
      if (menu.code === 'insertRow') {
        await this.$refs.xTable.insertAt({
          pid: 0,
          parentId: row.pid,
          todo99: '',
          todo98: ''
        })
        this.$nextTick(() => {
          this.$refs.xTable.setTreeExpand(row, true)
        })
      }
    },
    async insertOne() {
      // 定义缓存的父级id、最大的PID(用于新增组)
      let pid = -999
      let maxPID = -999
      // 遍历当前列表
      for (let row of this.$refs.xTable.getTableData().fullData) {
        // 如果单位相同且当前PID未赋值时赋值父级PID
        if (row.userCompany === this.myUserCompany && pid < 0 && row.children.length > 0) {
          pid = row.pid
        }
        // 寻找PID最大值
        if (Number(row.pid) > maxPID) {
          maxPID = Number(row.pid)
        }
      }
      // 遍历新增列表
      for (let row of this.$refs.xTable.getInsertRecords()) {
        if (row.userCompany === this.myUserCompany && pid < 0 && row.parentID === -1) {
          pid = row.pid
        }
        if (Number(row.pid) > maxPID) {
          maxPID = Number(row.pid)
        }
      }
      if (maxPID < 0) {
        maxPID = 0
      }
      // const that = this
      let { row } = await this.$refs.xTable.insertAt(
        {
          pid: maxPID + 1,
          parentId: -1,
          todo99: '',
          todo98: ''
        },
        -1
      )
      console.log(row)
      // that.$refs.xTable.insertAt(
      //   {
      //     pid: 0,
      //     parentId: 1,
      //     todo99: '步骤子节点',
      //     todo98: '预期子节点'
      //   }, -1)
      // this.$nextTick(() => {
      //   that.$refs.xTable.setTreeExpand(row, true)
      // })
    },
    // 粘贴前
    beforePasteMethod() {
      this.pasteAreaList = []
    },
    // 粘贴方法
    pasteMethod({ row, column, cellValue }) {
      // 只有这两列可以粘贴
      if (!['todo99', 'todo98'].includes(column.property)) {
        return
      }
      // 如果为父节点 且粘贴的是预期列则不然粘贴
      if (row.parentId === -1 && column.property === 'todo98') {
        return
      }
      row[column.property] = cellValue
      // 粘贴成功代表修改过数据了
      this.IfExistModify = true
      if (
        this.pasteAreaList.length > 0 &&
        this.pasteAreaList[this.pasteAreaList.length - 1]['endRow']['_XID'] !== row['_XID']
      ) {
        this.pasteAreaList[this.pasteAreaList.length - 1]['endRow'] = row
      }
      if (
        this.pasteAreaList.length > 0 &&
        this.pasteAreaList[this.pasteAreaList.length - 1]['endColumn']['property'] !== column['property']
      ) {
        this.pasteAreaList[this.pasteAreaList.length - 1]['endColumn'] = column
      }
      if (this.pasteAreaList.length === 0) {
        this.pasteAreaList.push({ startRow: row, endRow: row, startColumn: column, endColumn: column })
      }
    },
    // 粘贴后
    afterPasteMethod() {
      this.$nextTick(() => {
        this.$refs.xTable.clearCopyCellArea()
        this.$refs.xTable.setCellAreas(this.pasteAreaList)
      })
    },
    // cell激活控制
    activeMethod({ column, row }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      this.$refs.xTable.setCellAreas([{ startRow: row, endRow: row, startColumn: column, endColumn: column }])
      return false
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return false
    },
    // 绑定下拉框
    async BindComBox() {
      this.ComBoxItems.productionVersion = []
      this.ComBoxItems.productionType = []
      const { data: selectRes } = await this.$http.get('/Common/BMenuGroup/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'ProductionType':
              this.ComBoxItems.productionType.push(item)
              break
          }
        }
      }
    },
    // 当类型改变
    async changeType(type, isInit = false) {
      this.ComBoxItems.productionVersion = []
      if (!type || type === '') {
        this.form.productionVersion = ''
        return
      }
      const { data: res } = await this.$http.post(`/Common/ProductVersionSet/list?sqlTitle=${type}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data) {
        this.ComBoxItems.productionVersion.push({
          name: item.productionVersion,
          value: item.productionVersion
        })
      }
      const option = this.ComBoxItems.productionVersion.filter(item => {
        return item.value === this.form.productionVersion
      })
      if (!isInit && option.length <= 0) {
        this.form.productionVersion = ''
      }
    },
    // 进入窗口后
    showModal() {
      this.form = {
        productionType: '',
        productionVersion: '',
        todo1: '',
        todo2: '',
        todo3: '',
        todo4: '',
        todo5: '',
        todo6: '',
        todo7: '',
        todo8: '',
        lockDate: '',
        locker: '',
        lockerID: 0,
        writeDate: '',
        writer: '',
        writerID: 0,
        detailList: []
      }
      this.BindComBox()
    }
  },
  computed: {
    // 表高度
    tableHeight() {
      if (this.zoomType === 'revert') {
        return Number(this.$store.state.clientHeight) * 0.8 - 43 - 23 - 66 * 3 - 33 - 2 - 52 - 30 - 10 + 'px'
      } else {
        return Number(this.$store.state.clientHeight) - 43 - 23 - 66 * 3 - 33 - 2 - 52 - 30 - 10 + 'px'
      }
    }
  }
}
</script>
<style lang="less" scoped>
@gap-margin: 10px;
@gap-height: 30px;
.buttonContainer {
  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0 0 0;
  .fl;

  > button {
    padding: 0;
    width: 180px;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
  }
}
</style>
